export default function Comparison() {
  const comparisons = [
    {
      category: '見た目',
      mouthpiece: '透明で目立たない',
      traditional: '金属が目立つ',
      mouthpieceIcon: 'ri-eye-off-line',
      traditionalIcon: 'ri-eye-line',
      image: 'https://public.readdy.ai/ai/img_res/6808f9210cca7f3885252f4a886e67b5.jpg'
    },
    {
      category: '取り外し',
      mouthpiece: '食事・歯磨き時に外せる',
      traditional: '常に装着',
      mouthpieceIcon: 'ri-refresh-line',
      traditionalIcon: 'ri-lock-line',
      image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20woman%20in%20her%2030s%20easily%20removing%20clear%20aligners%20before%20eating%20a%20meal%20at%20a%20restaurant%2C%20bright%20natural%20lighting%2C%20modern%20casual%20dining%20setting%2C%20lifestyle%20photography%20showing%20convenience%20and%20flexibility&width=800&height=500&seq=comparison-removable&orientation=landscape'
    },
    {
      category: '痛み',
      mouthpiece: '比較的少ない',
      traditional: '調整時に痛みあり',
      mouthpieceIcon: 'ri-emotion-happy-line',
      traditionalIcon: 'ri-emotion-unhappy-line',
      image: 'https://readdy.ai/api/search-image?query=A%20comfortable%20and%20relaxed%20Japanese%20woman%20in%20her%2030s%20wearing%20clear%20aligners%20with%20a%20peaceful%20expression%2C%20soft%20natural%20lighting%2C%20cozy%20home%20setting%20in%20soft%20teal%20tones%2C%20lifestyle%20photography%20showing%20comfort%20and%20ease&width=800&height=500&seq=comparison-comfort&orientation=landscape'
    },
    {
      category: '通院頻度',
      mouthpiece: '1〜６ヶ月',
      traditional: '月1回程度',
      mouthpieceIcon: 'ri-calendar-check-line',
      traditionalIcon: 'ri-calendar-line',
      image: 'https://readdy.ai/api/search-image?query=A%20busy%20professional%20Japanese%20woman%20in%20her%2030s%20checking%20her%20calendar%20or%20phone%20with%20a%20relieved%20expression%2C%20bright%20modern%20office%20or%20home%20setting%2C%20professional%20lifestyle%20photography%20showing%20time%20flexibility%20and%20convenience&width=800&height=500&seq=comparison-schedule&orientation=landscape'
    }
  ];

  return (
    <section id="comparison" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            従来の矯正との<br />
            <span className="text-teal-600">違いは?</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            マウスピース矯正なら、こんなに違います
          </p>
        </div>

        <div className="space-y-12">
          {comparisons.map((comparison, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl overflow-hidden shadow-lg">
              <div className="grid lg:grid-cols-2 gap-0">
                <div className="relative h-64 lg:h-auto overflow-hidden">
                  <img 
                    src={comparison.image} 
                    alt={comparison.category} 
                    className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-cyan-500 opacity-10"></div>
                </div>
                
                <div className="p-8 lg:p-12">
                  <h3 className="text-3xl font-bold text-gray-900 mb-8 flex items-center gap-3">
                    <span className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-full text-teal-600 font-bold">
                      {index + 1}
                    </span>
                    {comparison.category}
                  </h3>
                  
                  <div className="space-y-6">
                    <div className="bg-teal-50 rounded-xl p-6 border-2 border-teal-200">
                      <div className="flex items-start gap-4">
                        <div className="w-12 h-12 flex items-center justify-center bg-teal-500 rounded-full flex-shrink-0">
                          <i className={`${comparison.mouthpieceIcon} text-2xl text-white`}></i>
                        </div>
                        <div className="flex-1">
                          <div className="text-sm font-semibold text-teal-600 mb-2">マウスピース矯正</div>
                          <div className="text-lg font-bold text-gray-900">{comparison.mouthpiece}</div>
                        </div>
                        <i className="ri-check-line text-3xl text-teal-600"></i>
                      </div>
                    </div>
                    
                    <div className="bg-gray-100 rounded-xl p-6 border-2 border-gray-200">
                      <div className="flex items-start gap-4">
                        <div className="w-12 h-12 flex items-center justify-center bg-gray-400 rounded-full flex-shrink-0">
                          <i className={`${comparison.traditionalIcon} text-2xl text-white`}></i>
                        </div>
                        <div className="flex-1">
                          <div className="text-sm font-semibold text-gray-500 mb-2">従来の矯正</div>
                          <div className="text-lg font-bold text-gray-700">{comparison.traditional}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-2xl p-8 md:p-12 text-white text-center">
          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            あなたに合った矯正方法を<br />無料でご提案します
          </h3>
          <p className="text-xl mb-8 opacity-90">
            まずはお気軽にご相談ください
          </p>
          <a href="#booking" className="inline-block bg-white text-teal-600 font-bold py-4 px-10 rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl text-lg whitespace-nowrap cursor-pointer">
            無料カウンセリング予約
          </a>
        </div>
      </div>
    </section>
  );
}